module.exports = __webpack_public_path__ + "img/home.d2aef49e.svg";